import { Box, Button, Card, Input, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import CreateTarifform from './Homecomponents/CreateTarifform';
import SearchIcon from '@mui/icons-material/Search';
import debounce from 'lodash/debounce';
import TarifTable from './Homecomponents/TarifTable';
import AltTarifTable from './Homecomponents/AltTarifTable';
function TarifHome({ caneditpage, data, upd }) {
    const [create, setcreate] = useState(false);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        handler();
        return () => handler.cancel();
    }, [searchTerm]);
    return (
        <>
            {
                caneditpage && !create && (
                    <Card variant='soft' sx={{ display: "flex", justifyContent: "space-between", flexDirection: "row", mb: 4 }}>
                        <Box>
                            <Typography level="title-md">Tarif erstellen</Typography>
                            <Typography>Erstellen sie einen neuen Tarif und Tragen sie ihre daten ein.</Typography>
                        </Box>
                        <Button sx={{ height: "5%", mt: 1 }} startDecorator={<AddBoxOutlinedIcon />} onClick={
                            () => setcreate(!create)
                        }>Erstellen</Button>

                    
                    </Card>
                )
            }
            {
                create && (<CreateTarifform setcr={setcreate} subkathid={data.id} />)
            }
            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                <Input
                    placeholder="Suche..."
                    startDecorator={<SearchIcon />}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ width: 600 }}
                />
            </Box>
            {data.tarifs && data.tarifs.filter(item => item.type === "konzept").filter(item => item.alttarif === false).filter(item =>
                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).length > 0 && (
                    <TarifTable
                        tablename="Konzepte"
                        data={data.tarifs
                            .filter(item => item.type === "konzept")
                            .filter(item => item.alttarif === false)
                            .filter(item =>
                                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
                            )}
                        kathid={data.id}
                    />
                )}
            {data.tarifs && data.tarifs.filter(item => item.type === "empfehlung")
                .filter(item => item.alttarif === false)
                .filter(item =>
                    item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
                .length > 0 && (
                    <TarifTable
                        tablename="Empfehlungen"
                        data={data.tarifs
                            .filter(item => item.type === "empfehlung")
                            .filter(item => item.alttarif === false)
                            .filter(item =>
                                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
                            )}
                        kathid={data.id}
                    />
                )}
            {data.tarifs && data.tarifs.filter(item => item.type === "tarif").filter(item => item.alttarif === false).filter(item =>
                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).length > 0 && (
                    <TarifTable
                        tablename="Tarife"
                        data={data.tarifs
                            .filter(item => item.type === "tarif")
                            .filter(item => item.alttarif === false)
                            .filter(item =>
                                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
                            )}
                        kathid={data.id}
                    />
                )}
            {data.tarifs && data.tarifs.filter(item => item.alttarif === true).filter(item =>
                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).length > 0 && (
                    <AltTarifTable
                        tablename="Alt-Tarife/Konzepte/Empfehlungen"
                        data={data.tarifs
                            .filter(item => item.alttarif === true)
                            .filter(item =>
                                item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
                            )}
                        kathid={data.id}
                    />
                )}


        </>
    )
}

export default TarifHome
